












































































import { Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import ContactProfileSummary from '@/components/Contacts/ContactProfileSummary.vue';
import SpecOutBrowseContactsSearchCriteria from '@/components/SpecOutContacts/SpecOutBrowseContactsSearchCriteria.vue';
import SpecOutStatus from '@/models/SpecOuts/SpecOutStatus';
import AddSpecOutContactsRequest from '@/models/SpecOuts/AddSpecOutContactsRequest';

@Component({
  name: 'SpecOutBrowseContacts',
  components: { ContactProfileSummary, SpecOutBrowseContactsSearchCriteria }
})
export default class extends GiganautVue {

	specOutStatusEnum = SpecOutStatus;
	page = 1;
	perPage = 8;

	existingContact(id: string){
		for (let index = 0; index < SpecOutDetailsModule.specOutContacts.length; index++) {
			const specOutContact = SpecOutDetailsModule.specOutContacts[index];
			if (specOutContact.contactId === id) {
				return true;
			}
		}
		return false;
	}

	get isSpecOutStatusDraft() {
		return SpecOutDetailsModule.currentSpecOut.status == SpecOutStatus.Draft
	}

	get selectedContactId() {
		return SpecOutDetailsModule.browseContactsVM.selectedContactId;
	}

	get selectedContactIds() {
		return SpecOutDetailsModule.browseContactsVM.selectedContactIds;
	}

	set selectedContactId(id: string) {
		SpecOutDetailsModule.browseContactsVM.selectedContactId = id;
	}

	get selectedContact() {
		return SpecOutDetailsModule.browseContactsVM.selectedContact;
	}

	get currentSpecOut() {
		return SpecOutDetailsModule.currentSpecOut;
	}

	get contactProfiles() {
		return SpecOutDetailsModule.browseContactsVM.contactProfiles;
	}

	get pagedContactProfiles() {
		return this.contactProfiles.slice((this.page - 1)* this.perPage, this.page* this.perPage)
	}

	@Watch('selectedContactId', { immediate: true })
    async onSelectedContactIdChanged(val: string, oldVal: string) {
	   if (val !== '') {
		   await SpecOutDetailsModule.updateSelectedBrowseContact(val);
	   }
	}

	async onPageChanged(input: number){
		SpecOutDetailsModule.browseContactsVM.selectedContactId = (this.pagedContactProfiles[0].entity.id);
	}

	get loadingContacts() {
		return SpecOutDetailsModule.loadingContacts;
	}

	async updateSelectedContactProfileIds(val: boolean, contactProfileId: string) {
    	if (val) {
			await SpecOutDetailsModule.addBrowseSelectedContactId(contactProfileId)
		} else {
			await SpecOutDetailsModule.removeBrowseSelectedContactId(contactProfileId)
		}
	}

	async addContactsToSpecOut() {
		if (SpecOutDetailsModule.browseContactsVM.selectedContactIds.length > 0) {
			const request = new AddSpecOutContactsRequest();
			request.contactIds = SpecOutDetailsModule.browseContactsVM.selectedContactIds;
			await SpecOutDetailsModule.addSpecOutContacts(request);
			await SpecOutDetailsModule.getSpecOutContacts();
		}
	}
}
